// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocationInfo_wrapper__12zd8","info":"LocationInfo_info__3foUz","favorite":"LocationInfo_favorite__3xMkB","image":"LocationInfo_image__3IEkv"};